import React, { Component } from 'react';
import Header from '../components/header';
import filesize from 'filesize';
import singleStore from '../stores/single-image-store.js';
import dispatcher from '../dispatcher.js';

class SingleImage extends Component {

	constructor(props) {
		super(props);

		this.state = {
			image: singleStore.getImage()
		}
		this.state = {
			hasCopied: false
		};

		this.copyUrl = this.copyUrl.bind(this);
		this.resetCopy = this.resetCopy.bind(this);
		this.backToDashboard = this.backToDashboard.bind(this);
		this.updateView = this.updateView.bind(this);
		this.getUrls = this.getUrls.bind(this);
	}

	componentDidMount() {
		singleStore.on('change', this.updateView)
		dispatcher.dispatch({
			type: 'getImage',
			bucket: this.props.match.params.bucket,
			uuid: this.props.match.params.id
		});
	}

	componentWillUnmount() {
		singleStore.removeListener('change', this.updateView);
	}

	updateView() {
		this.setState({
			image: singleStore.getImage()
		});
	}

	copyUrl() {
		var dummy = document.createElement("input");
		    document.body.appendChild(dummy);
		    dummy.value = this.state.image.cdnUrl;
		    dummy.select();
		    document.execCommand("copy");
		    document.body.removeChild(dummy);
		    this.setState({
		    	hasCopied: true
		    }, () => {
		    	setTimeout(this.resetCopy, 3000)
		    })
    }

    backToDashboard() {
    	this.props.history.push('/');
    }

    resetCopy() {
    	this.setState({
    		hasCopied: false
    	});
    }

    getUrls() {
    	let sizes = this.state.image.sizes.map((url, index) => {
    		return (
    			<a className="is-block" key={index} href={url} target="_blank" noopener="true">{url}</a>
    		)
    	})
    	return(
    		<React.Fragment>
    		<a className="is-block" href={this.state.image.cdnUrl} target="_blank" noopener="true">{this.state.image.cdnUrl}</a>
    		{sizes}
    		</React.Fragment>
    	);
    }

	render() {
		return (
			<React.Fragment>
				<Header subtitle="Image"/>
				<section className="section">
					<div className="container">
						<div className="columns">
							<div className="column">
							{ this.state.image ? 
								<div className="image is-16by9" style={{backgroundImage: `url(${this.state.image.cdnUrl})`}}>
								</div>
								: <div style={{margin: '0 auto', width: '5em', height: '5em'}} className="loader"></div>
							}
							</div>
							<div className="column">
								
								{this.state.hasCopied && <div style={{padding: '8px'}}className="notification has-text-left is-success">Link copiato!</div>}
								<div className="content has-text-left">
									<h2 className="title is-4">Nome immagine</h2>
									{ this.state.image ? <p>{this.state.image.filename}</p> : <div className="loader"></div>}
									<h2 className="title is-4">Dimensioni immagine</h2>
									{ this.state.image ? <p>{this.state.image.width}x{this.state.image.height}</p> : <div className="loader"></div>}
									<h2 className="title is-4">Dimensioni file</h2>
									{ this.state.image ? <p>{filesize(this.state.image.filesize)}</p> : <div className="loader"></div> }
									<h2 className="title is-4">Testata</h2>
									{ this.state.image ? <p>{this.state.image.bucket}</p> : <div className="loader"></div> }
									<h2 className="title is-4">Link immagine</h2>
									{ this.state.image ? this.getUrls() : <div className="loader"></div> }
								</div>
								<div className="field is-grouped">
									<div className="control">
										<button onClick={this.copyUrl} className="button is-info">Copia URL</button>
									</div>
									<div className="control">
										<button onClick={this.backToDashboard} className="button">Torna alla dashboard</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</React.Fragment>
		);
	}
}

export default SingleImage


// WEBPACK FOOTER //
// ./src/views/single.jsx